
import { defineComponent, onMounted, onUnmounted, reactive } from 'vue';
import {
  isProd as checkIsProd,
  Mock,
  injectLoginRequired,
} from './services/base.js';
import ChangePwdCrossTab from '@/components/ChangePwdDialog/crossTab';

export default defineComponent({
  components: {},

  setup() {
    // eslint-disable-line
    const mockState = reactive({
      mockType: '',
      typeQueue: ['local-mock', 'feonline-mock', 'real-api'],
    });

    const showLogin = (ele: Element) => {
      const event = new MouseEvent('click', {
        view: window,
        bubbles: true,
        cancelable: true,
      });

      ele.dispatchEvent(event);
    };
    injectLoginRequired(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (err: any) => {
        console.log(err);
      },
      () => {
        // 保证 login.js 执行完。
        setTimeout(() => {
          const $loginBtn: Element = document.body.querySelector(
            '#passport-login'
          ) as Element;
          showLogin($loginBtn);
          console.log('showLogin');
        }, 1000);
      }
    );

    onMounted(() => {
      mockState.mockType = Mock.get();
      if (location.host.indexOf('nuwarwe.net') > -1) {
        document.title = '中国妇瘤大数据平台（NUWA平台）';
      } else if (location.host.indexOf('henanbc') > -1) {
        document.title = 'HNBC';
      } else {
        document.title = '科研平台';
      }

      ChangePwdCrossTab.registiry();
    });

    onUnmounted(() => {
      ChangePwdCrossTab.unregistiry();
    });

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const mockMethods: any = {};
    const isProd = checkIsProd();
    if (!isProd) {
      mockMethods.toggleMock = () => {
        const type = mockState.mockType;
        if (type) {
          const index = mockState.typeQueue.indexOf(type);
          if (index !== mockState.typeQueue.length - 1) {
            Mock.set(mockState.typeQueue[index + 1]);
          } else {
            Mock.set(mockState.typeQueue[0]);
          }
        } else {
          // type 不存在, 默认设置为本地数据mock
          Mock.set('local-mock');
        }
        mockState.mockType = Mock.get();
      };
    }
    return {
      isProd,
      mockState,
      ...mockMethods,
    };
  },
});
